import Link from 'next/link';
import React from 'react';

import { Avatar, Typography } from '@sravni/react-design-system';

import { getPartnerNewsLink } from '../../../../helpers/news';
import { TOrganizationData } from '../../../../interfaces/news';
import styles from '../../styles.module.scss';

export const OrgTeg: React.FC<TOrganizationData> = ({ logotype, name, type, alias }) => {
  const linkProps = getPartnerNewsLink(type, alias);

  return (
    <Link {...linkProps}>
      <Typography.Link className={styles.link} href={linkProps.as}>
        <Avatar className={styles.logo} src={logotype} /> {name}
      </Typography.Link>
    </Link>
  );
};
